import { push } from 'react-router-redux';
import { PsRoutes } from '../shared/routing/Routes';

export const ATTACHMENT = {
    CLEAR: 'ATTACHMENT_CLEAR',
    SET_BACK_PATHNAME: 'ATTACHMENT_SET_BACK_PATHNAME',
    ADD_REMOVE: 'ATTACHMENT_ADD_REMOVE',
    ADD_ALL: 'ATTACHMENT_ADD_ALL',
    REMOVE_ALL: 'ATTACHMENT_REMOVE_ALL',
    SET_FILES: 'ATTACHMENT_SET_FILES',
};

export const goBack = (route) => (dispatch) => {
    dispatch(push(route));
};

// Almacenar la ruta actual desde la que se navega a la ventana de ATTACHMENT nos permitirá regresar a dicha ventana
// desde ATTACHMENT cuando el proceso de adjuntar finalice.
export const goToRouteAttachment = (currentPathname) => (dispatch) => {
    dispatch({
        type: ATTACHMENT.SET_BACK_PATHNAME,
        payload: currentPathname,
    });
    dispatch(push(PsRoutes.DOCUMENTS_ATTACHMENT));
};

export const clearAttachment = () => (dispatch) => {
    dispatch({
        type: ATTACHMENT.CLEAR,
    });
};

export const addOrRemoveDocToAttach = (doc) => (dispatch) => {
    dispatch({
        type: ATTACHMENT.ADD_REMOVE,
        payload: doc,
    });
};

export const addAlldocsToAttach = (docs) => (dispatch) => {
    dispatch({
        type: ATTACHMENT.ADD_ALL,
        payload: docs,
    });
};

export const removeAllDocsToAttach = (docs) => (dispatch) => {
    dispatch({
        type: ATTACHMENT.REMOVE_ALL,
        payload: docs,
    });
};

export const setAttachedFiled = (files) => (dispatch) => {
    dispatch({
        type: ATTACHMENT.SET_FILES,
        payload: files,
    });
};



// WEBPACK FOOTER //
// ./src/app/attachment/attachmentActions.js